module.exports = __webpack_public_path__ + "static/img/undraw.fb398ee5.fb398ee5.png";